// Module
var code = "<div class=bible> <div class=bibletext> <p> </p><h2 class=pn>Psalm&nbsp;114</h2><p><span class=cwvnum>1</span>&nbsp;&nbsp;When Israel came out of Egypt,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;the house of Jacob from a people of a strange tongue,<br> </p> </div></div>";
// Exports
module.exports = code;